<template>
  <span class="tsp" :class="'tsp--' + kind"><span class="tsp__dot" aria-hidden="true"></span>{{ label }}</span>
</template>

<script>
// Status eines Shop-Tickets als farbiges Etikett (Kundenwunsch 14.10.2026: „der status sollte zudem noch weiter vorne
// sichtbar sein. grün für abgeschlossen gelb für offen und rot für storniert“): Abgeschlossen grün (--green-t /
// --green-fg, Punkt --green-dot), Offen gelb (--amber-t / --amber, Punkt --st-warn), Storniert rot (--red-t / --red),
// unbekannte Werte neutral. Genutzt in der Tabelle und im Detail der Shop-Tickets.
import { TICKET_STATUS_TEXT } from '@/components/shop/shopFilters';

const KIND = { FINISHED: 'done', OPEN: 'open', CANCELED: 'canceled' };

export default {
  name: 'TicketStatusPill',
  props: {
    status: { type: String, default: '' },
    text: { type: String, default: '' }
  },
  computed: {
    kind() {
      return KIND[this.status] || 'other';
    },
    label() {
      return this.text || TICKET_STATUS_TEXT[this.status] || this.status || '–';
    }
  }
};
</script>

<style scoped>
.tsp {
  display: inline-block;
  height: 22px;
  box-sizing: border-box;
  padding: 0 7px;
  border-radius: 999px;
  background: var(--tint);
  color: var(--ink-2);
  font-size: 12px;
  line-height: 22px;
  font-weight: 600;
  white-space: nowrap;
  vertical-align: middle;
}
.tsp__dot {
  display: inline-block;
  width: 7px;
  height: 7px;
  margin: -2px 6px 0 0;
  border-radius: 50%;
  background: var(--ink-4);
}
.tsp--done {
  background: var(--green-t);
  color: var(--green-fg);
}
.tsp--done .tsp__dot {
  background: var(--green-dot);
}
.tsp--open {
  background: var(--amber-t);
  color: var(--amber);
}
.tsp--open .tsp__dot {
  background: var(--st-warn);
}
.tsp--canceled {
  background: var(--red-t);
  color: var(--red);
}
.tsp--canceled .tsp__dot {
  background: var(--red);
}
</style>
